export default __webpack_public_path__ + "static/media/the_hierophant.1dd4df83.png";